/* @flow */

import React, { useEffect } from "react";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import { useLocation, useHistory } from "react-router";
import usePrevious from "helpers/use-previous";
import useCheckoutSteps from "helpers/use-checkout-steps";
import Notifications from "components/Notifications";
import Nav from "./Nav";
import Banner from "./Banner";
import { Button } from "@crossroads/ui-components";
import { QuoteData } from "data";
import { useData } from "crustate/react";
import { MODE } from "state/view-mode";
import { useUi } from "helpers/ui";
import SystemMessages from "components/SystemMessages";
import ChevronIcon from "icons/chevron.svg";

import styles from "./styles.scss";

const AppHeader = () => {
  const location = useLocation();
  const { setHamburgerOpen, setSubNavOpen, setViewMode } = useUi();
  const quoteData = useData(QuoteData);
  const prevQuoteData = usePrevious(quoteData);
  const onCheckout = (location ? location.pathname : "").includes("checkout") &&
    !(location ? location.pathname : "").includes("success");

  // Open mini cart when adding to cart
  useEffect(() => {
    if (location.pathname === "/checkout" ||
        !prevQuoteData ||
        (quoteData.state !== "LOADED" || prevQuoteData.state !== "ADDING_ITEM")) {
      return;
    }

    const count = quoteData.data.items.reduce((a, { qty }) => a + qty, 0);
    const prevCount = prevQuoteData.data.items.reduce((a, { qty }) => a + qty, 0);

    if (count > prevCount) {
      setViewMode(MODE.CART);
      setSubNavOpen(false);
      setHamburgerOpen(false);
    }
  }, [setViewMode, prevQuoteData, quoteData, location, setSubNavOpen, setHamburgerOpen]);

  return (
    <div className={cn(styles.block, { [styles.onCheckout]: onCheckout })}>
      <Notifications />
      <SystemMessages />
      <Nav onCheckout={onCheckout} />
      {onCheckout && <MobileCheckout />}
      {!onCheckout &&
        <Banner />
      }
    </div>
  );
};

const MobileCheckout = () => {
  const t = useTranslate();
  const history = useHistory();
  const { steps, currentStep } = useCheckoutSteps();

  return (
    <div className={styles.mobileCheckout}>
      <div className={styles.content}>
        <Button className={styles.back} onClick={() => history.goBack()}><ChevronIcon aria-label={t("ICONS.CHEVRON")} /></Button>
        <div className={styles.steps}>
          <span className={styles.counter}>{`${currentStep.key} ${t("CART.OF")} ${steps.length}`}</span>
          <span className={styles.title}>{currentStep.title}</span>
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
